import { ChangeEvent, KeyboardEvent, useState } from 'react';

import { Select } from 'components/DesignSystem/Select';
import { InputOption } from 'components/DesignSystem/Select/components/InputOption/InputOption';
import { ValueContainer } from 'components/DesignSystem/Select/components/ValueContainer/ValueContainer';
import { Switch } from 'components/DesignSystem/Switch';
import { TextInput } from 'components/DesignSystem/TextInput/TextInput';
import classes from 'components/widgets/ScheduleSimulation/components/SimulatedActivitiesTable/SimulatedActivitiesFilter/SimulatedActivitiesFilters.module.scss';
import { useSimulatedActivitiesFiltersStore } from 'components/widgets/ScheduleSimulation/components/SimulatedActivitiesTable/SimulatedActivitiesFilter/simulatedActivitiesFilter.store';
import {
    activitiesTabActivityTypeInitialOptions,
    statusOptions,
} from 'components/widgets/ScheduleSimulation/components/SimulatedActivitiesTable/SimulatedActivitiesFilter/simulatedActivitiesFilter.utils';

export const SimulatedActivitiesFilters = () => {
    const [searchText, setSearchText] = useState<string>('');
    const { isCriticalPathChangedFilter, isCriticalPathFilter, statusFilter, activityTypeFilter, update, activeTab } =
        useSimulatedActivitiesFiltersStore();

    const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
            update({ search: searchText });
        }
    };

    return (
        <div className={classes.filters}>
            <div className={classes.selectWrapper}>
                <div className={classes.filterTextSearch}>
                    <TextInput
                        placeholder={'Search Activities by Name'}
                        value={searchText}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            setSearchText(e.target.value);
                        }}
                        onClear={() => {
                            setSearchText('');
                            update({ search: '' });
                        }}
                        maxLength={200}
                        onKeyDown={onKeyDown}
                        className={classes.textInput}
                        label={'Name'}
                        searchable={true}
                        onSearch={() => update({ search: searchText })}
                    />
                </div>
            </div>
            {activeTab === 'activities' && (
                <>
                    <div className={classes.selectWrapper}>
                        <div className={classes.title}>Activity Type</div>
                        <Select<ISelectOption<string>, true>
                            value={activityTypeFilter}
                            options={activitiesTabActivityTypeInitialOptions}
                            id={'activity-type-filter'}
                            onChange={(value) => update({ activityTypeFilter: [...value] })}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            isMulti={true}
                            placeholder={'Select Activity Type...'}
                            components={{
                                Option: InputOption,
                                ValueContainer: ValueContainer,
                            }}
                        />
                    </div>
                    <div className={classes.selectWrapper}>
                        <div className={classes.title}>Status</div>
                        <Select<ISelectOption<string>, true>
                            value={statusFilter}
                            options={statusOptions}
                            id={'status-filter'}
                            onChange={(value) => update({ statusFilter: [...value] })}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            isMulti={true}
                            placeholder={'Select Status...'}
                            components={{
                                Option: InputOption,
                                ValueContainer: ValueContainer,
                            }}
                        />
                    </div>
                    <div>
                        <Switch
                            onChange={(e) =>
                                update({
                                    isCriticalPathFilter: e.target.checked,
                                })
                            }
                            checked={isCriticalPathFilter}
                            label={'Critical Path (Post Simulation)'}
                            labelPlacement={'start'}
                        />
                    </div>
                    <div>
                        <Switch
                            onChange={(e) =>
                                update({
                                    isCriticalPathChangedFilter: e.target.checked,
                                })
                            }
                            checked={isCriticalPathChangedFilter}
                            label={'Critical Path Changed'}
                            labelPlacement={'start'}
                        />
                    </div>
                </>
            )}
        </div>
    );
};
